export interface PaymentI {
  id: number;
  amount: number;
  created: number;
  externalReference: string;
  paymentMethod: string;
  paymentStatus: string;
  planId: number;
  transactionId: string;
  transactionLinkId: string;
  updated: number;
  userId: number;
}

export interface PaymentStateI {
  payments: PaymentI[];
  payment: PaymentI; // Optional, used when a single payment is needed
}

export const state: PaymentStateI = {
  payments: [],
  payment: {
    id: 0,
    amount: 0,
    created: 0,
    externalReference: '',
    paymentMethod: '',
    paymentStatus: '',
    planId: 0,
    transactionId: '',
    transactionLinkId: '',
    updated: 0,
    userId: 0,
  },
};
